import PropTypes from 'prop-types';
import React from 'react'
import ReactDOM from 'react-dom'
import { findWhere } from 'underscore'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { getCampFeed, getNewCampFeed, getOlderCampFeed, getMainFeed, getOlderMainFeed, resetAllPostsLoaded } from '~/actions/feed'
import { getCamp, getRecommendedCamps } from '~/actions/camps'

// Components
import CampHeader from './CampParts/CampsPart-Header'
import DashboardHeader from './DashboardParts/DashboardHeader'
import RecommendedCamps from './DashboardParts/RecommendedCamps'
import TodaysNotice from './DashboardParts/TodaysNotice'
import EmailFrequency from '../Profile/components/Body/components/EmailFrequency'

import MainFeed from './MainFeeds/DashboardFeed-Main'
import CampFeed from './MainFeeds/DashboardFeed-Camps'

import LeftSideBar from './SideBarLeft/SideBar-Master'
import RightSideBar from './SideBarRight/SideBar-Master'

import {
	MetaData
} from '~/components'
import {
	Onboarding
} from './components'
import {
	TextLoader,
	PostLoader
} from '~/components/Loaders'

// Services
import { Icons } from '~/services'



class Community extends React.Component {
    static propTypes = {
		feed: PropTypes.object.isRequired,
		isBackgroundContent: PropTypes.bool
	};

    constructor(props, context) {
        super(props, context);

        var cookies = document.cookie.split("; "),
			sideBarCookie = cookies.filter(cookie => { var split = cookie.split('='); return split[0] == this.cookieName }),
			sideBarFilter = sideBarCookie.length > 0 ? sideBarCookie[0].split('=') : ['bookmarks'],
			state = { 
				editingUsers: false, 
				filteredSideBar: sideBarFilter.length > 1 ? sideBarFilter[1] : sideBarFilter[0]
			},
			sessionCamp = findWhere(props.session.camps, {url_slug: props.match.params.slug});

        this.isCampPage = !!props.match.params.slug && ('path' in props.route) && !!/camp\/.+/.exec(props.route.path);
        if( this.isCampPage && !!sessionCamp && !this.isAdmin(sessionCamp) ) state.camp = sessionCamp;

        this.state = state;
    }

    cookieName = 'boma_camp_sidebar_preference';
    isCampPage = false;

    componentWillMount() {

		// this.props.resetAllPostsLoaded()
        //
		// // if( 'ID' in this.props.session.user && !this.props.session.user.verified_email ) this.props.history.push('/discover/')
        //
		// if( this.isCampPage ) {
        //
		// 	if( !this.state.camp ) this.props.getCamp(this.props.match.params.slug)
		// 	if( !this.props.isModalChild || !this.props.feed.posts.length ) {
		// 		this.props.getCampFeed(this.props.match.params.slug)
		// 	} else {
		// 		this.props.getNewCampFeed( this.props.match.params.slug, this.props.feed.posts.length > 0 ? this.props.feed.posts[0].ID : 0 )
		// 	}
        //
		// } else if( !this.props.isModalChild || !this.props.feed.posts.length ) {
        //
		// 	this.props.getMainFeed()
		// 	this.props.getRecommendedCamps()
        //
		// }

	}

    componentDidMount() {
		window.scroll(0,0)
        document.addEventListener('scroll', this.loadNextPosts)
	}

    componentWillUpdate(nextProps) {
		// if( 'ID' in nextProps.session.user && !nextProps.session.user.verified_email ) this.props.history.push('/discover/')
		if( nextProps.feed.posts.length === 4 && !nextProps.feed.fetching.oldPosts && !nextProps.feed.allPostsLoaded ) {
			if( this.isCampPage ) {
				this.props.getOlderCampFeed(this.props.match.params.slug, 4, 4)
			} else {
				this.props.getOlderMainFeed(4, 4)
			}
		}
	}

    loadNextPosts = (element) => {
		if( !!this.props.feed.fetching.oldPosts || !!this.props.feed.allPostsLoaded ) return
		let dom = ReactDOM.findDOMNode(this.refs.container);
		if( !dom ) return;
		let bounding = dom.getBoundingClientRect();
		if( +(bounding.bottom - 20) >= +window.innerHeight ) return
        if( this.isCampPage ) {
			this.props.getOlderCampFeed(this.props.match.params.slug, 8, this.props.feed.posts.length)
        } else {
			this.props.getOlderMainFeed(8, this.props.feed.posts.length)
        }
	};

    canAccess = () => {
		if( !this.isCampPage ) return true;
		var camp = this.state.camp ? this.state.camp : this.props.camp.post;
		if( camp.visibility == 'public' ) return true;
		if( camp.status == 'joined' ) return true;
		if( camp.status == 'admin' ) return true;
		return false;
	};

    isAdmin = (campCheck) => {
		if( !this.isCampPage ) return false;
		var camp = campCheck ? campCheck : (this.state.camp ? this.state.camp : this.props.camp.post);
		if( !camp ) return false;
		return ('ID' in this.props.session.user) && ('owner' in camp) && (camp.owner.ID == this.props.session.user.ID);
	};

    changeTab = (filter) => {
		this.setState({
			filteredSideBar: filter
		})
		document.cookie = this.cookieName+'='+filter+'; path=/'
	};

    toggleEditUsers = () => {
		this.setState({
			editingUsers: !this.state.editingUsers
		})
	};

    render() {

		var selectedFilter = this.props.match.params.slug,
			camp = this.isCampPage
				? this.isAdmin() || !this.state.camp ? this.props.camp.post : this.state.camp
				: {},
			fetchingSidebar = selectedFilter === 'bookmarks' ? this.props.session.fetching.bookmarks : this.props.session.fetching.history;

		return (

			<div>

				<Onboarding {...this.props} />

				{ !this.props.session.fetching.user && (
					'title' in camp
						? <MetaData page="camp" vars={camp} />
		                : <MetaData page="dashboard" />
	            ) }

				{ !!camp && 'ID' in camp && 
					<CampHeader {...camp}
								toggleEditUsers={this.toggleEditUsers}
								editing={this.state.editingUsers} /> 
				}

				<div className="container" ref="container">

					<div className="visible-md visible-lg"><DashboardHeader filter={this.state.filteredSideBar} changeTab={this.changeTab} /></div>

					<div className="row">

			            <div className="col-md-2 col-sm-3">

		            		<LeftSideBar 	selectedFilter={selectedFilter} 
											session={this.props.session} />

			            </div>

			            <div className="col-md-7 col-sm-9 pright0 pleft0 pright15-xs pleft15-xs">

			            	{ !('ID' in camp) && this.props.session.recommendedCamps.length > 0 && !this.props.session.fetching.recommendedCamps &&
								<RecommendedCamps camps={this.props.session.recommendedCamps} feedLength={this.props.feed.posts.length} />
			            	}

			            	{ !('ID' in camp) && !!this.props.feed.posts.length && !this.props.feed.fetching.posts &&
								<TodaysNotice />
			            	}

							{ !!camp && 'ID' in camp 
								? <CampFeed campSlug={this.props.match.params.slug} camp={camp} canAccess={this.canAccess} editingUsers={this.state.editingUsers} />
								: <MainFeed />
							}

							{ !this.props.feed.fetching.posts && this.props.feed.fetching.oldPosts && <PostLoader classes="mbot40" /> }

			            </div>

			            { !fetchingSidebar &&
				
				            <div className="col-md-3 col-xs-12 pbot10">

								<div className="visible-sm visible-xs"><DashboardHeader filter={this.state.filteredSideBar} changeTab={this.changeTab} hideCamps={true} /></div>

				            	<RightSideBar 	session={this.props.session}
				            					filter={this.state.filteredSideBar}
				            					feed={this.props.feed} />

				            </div>

				        }

			        </div>

	        	</div>

	        </div>

		)

	};

	componentWillUnmount() {
        document.removeEventListener('scroll', this.loadNextPosts)
	};

}

const mapStateToProps = state => ({
    session: state.session,
    feed: state.feed,
    notifications: state.notifications,
});

const mapDispatchToProps = dispatch => bindActionCreators({ resetAllPostsLoaded, getCamp, getCampFeed, getNewCampFeed, getOlderCampFeed, getOlderMainFeed, getMainFeed, getRecommendedCamps }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Community );




// WEBPACK FOOTER //
// ./src/js/views/Community/index.jsx